<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaRegistroEventos
      :titulo="$t ('Registro de eventos')"
      icono="mdi-arrow-left-right-bold"
      :campos="['fechor+', 'id_ins', 'id_apa', 'id_tipeve', 'id_empinq', 'id_tippas', 'nom', '__datadi', 'matrec', 'salcon-', 'saldis-']"
      busqueda-rapida
      :campos-filtrables="['fechor', 'id_ins', 'id_tipeve', 'id_empinq', 'id_tippas']"
      :filas-por-pagina="20"
      :zoom="0.92"
      dense
     />

  </v-container>
</template>

<script>
import TablaRegistroEventos from "@/components/TablaRegistroEventos.vue";

export default {
  components: {
    TablaRegistroEventos
  }
};
</script>

<style>
</style>